module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--profile-11d4c8c41d90abb38ee96f76ce20c5c1.svg";